import { render, staticRenderFns } from "./DoctorDocumentsList.vue?vue&type=template&id=0aadf18e&scoped=true"
import script from "./DoctorDocumentsList.vue?vue&type=script&lang=js"
export * from "./DoctorDocumentsList.vue?vue&type=script&lang=js"
import style0 from "./DoctorDocumentsList.vue?vue&type=style&index=0&id=0aadf18e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aadf18e",
  null
  
)

export default component.exports